$(document).ready(function () {

  function bodyScroll(state) {
    if (state == 'disable') {
      $('body').addClass('no-overflow');
      $('html').addClass('no-overflow');
    } else {
      $('body').removeClass('no-overflow');
      $('html').removeClass('no-overflow');
    }
  }

  function toggleModal(e, command, targetName) {
    e.preventDefault();
    e.stopPropagation();
    var $targetModal = $('[data-modal-name="' + targetName + '"]');
    if (command == 'show') {
      $targetModal.scrollTop(0);
      $targetModal.addClass('open');
      $targetModal.trigger('modal-opened');
      bodyScroll('disable');
    } else if (command == 'hide') {
      $targetModal.removeClass('open');
      bodyScroll('enable');
    }
  }

  function showModal(e) {
    var targetName = $(this).data('target');
    toggleModal(e, 'show', targetName);
  }

  function hideModal(e) {
    var targetName = $(this).data('target');
    toggleModal(e, 'hide', targetName);
  }

  // Close all modals on esc Key
  $(document).keydown(function (e) {
    if (e.keyCode == 27) {
      $('.modal').removeClass('open');
      bodyScroll('enable');
    }
  });

  // Register all modal buttons
  $('.modal-open').click(showModal);
  $('.modal-close').click(hideModal);

});
